import React from 'react';
import PropTypes from 'prop-types';
import { content as ContentPropType } from 'lib/CustomPropTypes';
import Bacon from 'components/packages/Bacon';
import { appendTracking, appendTrackingUnibrow } from '../utility';

const MsnbcDailyAuthors = ({
  content,
  seeAllText,
  seeAllUrl,
  title,
  vertical,
}) => {
  const modifiedContent = {
    ...content,
    metadata: {
      seeAllUrl,
      seeAllText,
      title,
    },
  };
  const trackingType = 'pkgColumnist';

  // Append tracking to content and unibrow links
  modifiedContent.items.forEach((row) => {
    const {
      computedValues, item, metadata, related, type,
    } = row;
    if (typeof computedValues.url !== 'undefined') {
      computedValues.url = appendTracking(computedValues.url, trackingType);
    }
    if (typeof computedValues.unibrow !== 'undefined') {
      computedValues.unibrow = appendTrackingUnibrow(computedValues.unibrow, trackingType);
    }
    return {
      computedValues, item, metadata, related, type,
    };
  });

  return (
    <div className="msnbcDaily__authors">
      <div className="msnbcDaily__header-border" />
      <Bacon
        content={modifiedContent}
        vertical={vertical}
      />
    </div>
  );
};

MsnbcDailyAuthors.propTypes = {
  content: PropTypes.shape({
    cardType: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(ContentPropType).isRequired,
  }).isRequired,
  seeAllText: PropTypes.string,
  seeAllUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
  vertical: PropTypes.string.isRequired,
};

MsnbcDailyAuthors.defaultProps = {
  seeAllText: null,
  seeAllUrl: null,
};

export { MsnbcDailyAuthors };
